import { useEffect, useRef } from 'react';
import { useAuthStore } from '../stores';
import { getAccessTokenExpiryMs, refreshAccessToken } from '../util/tokenRefresh';

const REFRESH_BEFORE_MS = 5 * 60 * 1000;

/**
 * Proactively refreshes the access token before it expires.
 */
export function useTokenRefresh(): void {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const accessToken = useAuthStore((state) => state.accessToken);
  const timerRef = useRef<number | null>(null);

  useEffect(() => {
    if (!isAuthenticated || !accessToken) {
      return;
    }

    const expiryMs = getAccessTokenExpiryMs(accessToken);
    if (!expiryMs) {
      return;
    }

    const delay = Math.max(expiryMs - Date.now() - REFRESH_BEFORE_MS, 0);

    timerRef.current = window.setTimeout(() => {
      void refreshAccessToken();
    }, delay);

    return () => {
      if (timerRef.current !== null) {
        window.clearTimeout(timerRef.current);
      }
    };
  }, [isAuthenticated, accessToken]);
}
